import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { cloneElement, isValidElement } from 'react';
import styled, { css } from 'styled-components';
import Heading from '@nib-components/heading';
import { copyColor } from '@nib-components/theme';
import { pickFgColor, Margin, map, mb, breakpoint, Box } from '@nib/layout';
export const validTitleValues = ['h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'div', 'label', 'span', 'header'];
const isReactNode = component => /*#__PURE__*/isValidElement(component);
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const IconWrapper = styled(_ref => {
  let {
    display,
    iconFill,
    ...rest
  } = _ref;
  return /*#__PURE__*/_jsx("div", {
    ...rest
  });
})`
  ${mb(5)};

  ${_ref2 => {
  let {
    iconFill
  } = _ref2;
  return iconFill && css`
      color: ${pickFgColor(iconFill)};
    `;
}}

  ${_ref3 => {
  let {
    display
  } = _ref3;
  return map(display, val => val ? 'display: block;' : 'display: none;');
}};
`;
export const Content = styled.div`
  display: inline-block;
  max-width: 30em;
  margin: auto;
  font-family: ${_ref4 => {
  let {
    theme
  } = _ref4;
  return theme.fonts && theme.fonts.sansSerif || theme.fonts.copy || 'sans-serif';
}};
  color: var(--themeColorFg, ${copyColor});
  word-break: break-word;
  hyphens: auto;

  ${breakpoint('mini')`
    hyphens: none;  
  `}
`;
const Feature = props => {
  const {
    icon: Icon,
    iconFill,
    displayIcons,
    title,
    titleComponent = 'h3',
    children,
    ...otherProps
  } = props;
  const featureTitle = title && /*#__PURE__*/_jsx(Margin, {
    bottom: 5,
    children: /*#__PURE__*/_jsx(Heading, {
      size: 4,
      component: titleComponent,
      children: title
    })
  });
  return /*#__PURE__*/_jsxs(Box, {
    height: "100%",
    textAlign: "center",
    ...otherProps,
    "data-mesh-component": "FEATURE",
    children: [/*#__PURE__*/_jsx(IconWrapper, {
      display: displayIcons,
      iconFill: iconFill,
      children: isReactNode(Icon) ? /*#__PURE__*/cloneElement(Icon, {
        size: 'xl'
      }) : /*#__PURE__*/_jsx(Icon, {
        size: "xl"
      })
    }), featureTitle, /*#__PURE__*/_jsx(Content, {
      children: children
    })]
  });
};
Feature.displayName = 'FeaturePanel.Feature';
export default Feature;